export interface Usuario {
    name: string;
    positionGroup: string,
    status: string,
    email: string
  }
  export interface Fundo {
    code: string;
    name: string;
  }
  
  export class Grupo {
    id: string;
    name: string;
    users: Usuario[];
    funds: Fundo[];
    constructor() {
    }
  }

  export interface Grupos {
    grupos: Grupo[];
  }

  export interface InstitutionOwner {
    id: string;
    cnpj: string;
    fantasyName: string;
    legalName: string;
    permissionGroups?: any;
    totalUsers: number;
    totalFunds: number;
}

export interface Type {
    typeEnum: string;
    type: string;
}

export interface Role {
    id: string;
    name: string;
    description: string;
    status: number;
    type: Type;
    checked: boolean;
}

export interface PermissionGroup {
    id: string;
    name: string;
    institution?: any;
    description?: any;
    roles: Role[];
    users?: any;
}

export interface InvestmentFund {
    idInvestmentFund: string;
    cpnjFoud?: any;
    name: string;
    providerType: string;
    code: string;
}

export interface InvestmentGroup {
    id: string;
    investmentFunds: InvestmentFund[];
    institution?: any;
    users?: any;
    name: string;
    description?: any;
    status: number;
    totalUsers: number;
    totalFunds: number;
}

export interface User {
    id: string;
    login: string;
    institutionOwners: InstitutionOwner[];
    permissionGroups: PermissionGroup[];
    investmentGroups: InvestmentGroup[];
    cpf?: any;
    passport?: any;
    nationality: string;
    documentNumber: string;
    name: string;
    birthDate: string;
    rg: string;
    cellNumber: string;
    internationalPrefix: string;
    status: string;
    language: string;
    createdByUser?: any;
    idUserBackoffice?: any;
    reason?: any;
    creationDate?: any;
}
